import React from 'react';
import PropTypes from 'prop-types';
import { propTypes } from '../../util/types';
import { Slider, LiveRoomCard } from '../../components';
import classNames from 'classnames';

import css from './SectionLiveRooms.module.css';

// slidesToShow
const SLIDES_TO_SHOW_TABLET = 2;
const SLIDES_TO_SHOW_DESKTOP = 4;
// slidesToScroll
const SLIDES_TO_SCROLL_TABLET = 2;
const SLIDES_TO_SCROLL_DESKTOP = 2;

const SectionLiveRooms = props => {
  const {
    rootClassName,
    className,
    titleClassName,
    arrowsClassName,
    intl,
    liveRooms,
    queryLiveRoomsInProgress,
    queryLiveRoomsError,
    slidesToShow,
    slidesToScroll,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const titleClasses = classNames(css.title, titleClassName);

  // Keep the server-rendered slider on screen during post-hydration
  // refetches — hide only when there's nothing to show (see
  // SectionListings for the full story).
  if (queryLiveRoomsError || (queryLiveRoomsInProgress && (!liveRooms || liveRooms.length === 0))) {
    return null;
  }

  const sliderTitle = intl.formatMessage({ id: 'SectionLiveRooms.title' });
  return (
    <div className={classes}>
      <Slider
        id="LandingPage.experiencesSlider"
        headerClassName={css.header}
        titleClassName={titleClasses}
        title={sliderTitle}
        itemClassName={css.sliderItem}
        arrowsClassName={arrowsClassName}
        slidesToShow={{
          tablet: slidesToShow?.tablet || SLIDES_TO_SHOW_TABLET,
          desktop: slidesToShow?.desktop || SLIDES_TO_SHOW_DESKTOP,
        }}
        slidesToScroll={{
          tablet: slidesToScroll?.tablet || SLIDES_TO_SCROLL_TABLET,
          desktop: slidesToScroll?.desktop || SLIDES_TO_SCROLL_DESKTOP,
        }}
      >
        {liveRooms.map(l => {
          return <LiveRoomCard key={l.id.uuid} listing={l} />;
        })}
      </Slider>
    </div>
  );
};

SectionLiveRooms.defaultProps = {
  rootClassName: null,
  className: null,
  titleClassName: null,
  arrowsClassName: null,
  queryLiveRoomsInProgress: false,
  queryLiveRoomsError: null,
};

const { arrayOf, bool, string } = PropTypes;

SectionLiveRooms.propTypes = {
  rootClassName: string,
  className: string,
  titleClassName: string,
  arrowsClassName: string,

  liveRooms: arrayOf(propTypes.listing),
  queryLiveRoomsInProgress: bool.isRequired,
  queryLiveRoomsError: propTypes.error,
};

export default SectionLiveRooms;
